import { Type } from '@angular/core';
import { GridRegistrationFormBase } from '@bo-client/activation-management/grid-registration/grid-registration-form.base';
import { GridRegistrationTypeEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { GridRegistrationFormFeederComponent } from '@bo-client/activation-management/grid-registrations/grid-registration-form-v2/grid-registration-form-feeder/grid-registration-form-feeder.component';
import { GridRegistrationFormConsumerComponent } from '@bo-client/activation-management/grid-registrations/grid-registration-form-v2/grid-registration-form-consumer/grid-registration-form-consumer.component';
import { GridRegistrationFormComponent } from '@bo-client/activation-management/grid-registration/grid-registration-form/grid-registration-form.component';
import { GridRegistrationExternalFormComponent } from '@bo-client/activation-management/grid-registration/forms/grid-registration-external-form/grid-registration-external-form.component';
import {
  ConsumerModel,
  ConsumerType
} from '@bo-client/activation-management/grid-registration/model/consumer.model';
import { GridRegistrationChangeMeteringConceptComponent } from '@bo-client/activation-management/grid-registrations/grid-registration-form-v2/grid-registration-change-metering-concept/grid-registration-change-metering-concept.component';
import { GridRegistrationFormStorageWrapperComponent } from '@bo-client/activation-management/grid-registrations/grid-registration-form-v2/grid-registration-form-storage-wrapper/grid-registration-form-storage-wrapper.component';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { StorageOperationTypeEnum } from '@bo-client/activation-management/grid-registration/model/storage.model';

export function getComponentForGridRegistrationType(
  gridRegistrationType: GridRegistrationTypeEnum,
  componentVersion: 'v1' | 'v2' = null
): Type<GridRegistrationFormBase> {
  /**
   * Es gibt eine neue Version des Netzanmeldungsformulars (v2).
   */
  if (componentVersion === 'v1') {
    if (gridRegistrationType === GridRegistrationTypeEnum.Storage) {
      return GridRegistrationFormConsumerComponent;
    }
    return GridRegistrationFormComponent;
  } else {
    switch (gridRegistrationType) {
      case GridRegistrationTypeEnum.Feeder:
        return GridRegistrationFormFeederComponent;
      case GridRegistrationTypeEnum.Charger:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.EHeating:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.Misc:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.Storage:
        return GridRegistrationFormStorageWrapperComponent;
      case GridRegistrationTypeEnum.PlugInProducer:
        return GridRegistrationFormComponent;
      case GridRegistrationTypeEnum.ChangeMeteringConcept:
        return GridRegistrationChangeMeteringConceptComponent;
    }
  }
}

export function getComponentForGridRegistrationExternalType(
  gridRegistrationType: GridRegistrationTypeEnum,
  componentVersion: 'v1' | 'v2' = null
): Type<GridRegistrationFormBase> {
  /**
   * Es gibt eine neue Version des Netzanmeldungsformulars (v2).
   */
  if (componentVersion === 'v1') {
    if (gridRegistrationType === GridRegistrationTypeEnum.Storage) {
      return GridRegistrationFormConsumerComponent;
    }
    return GridRegistrationExternalFormComponent;
  } else {
    switch (gridRegistrationType) {
      case GridRegistrationTypeEnum.Feeder:
        return GridRegistrationFormFeederComponent;
      case GridRegistrationTypeEnum.Charger:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.EHeating:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.Misc:
        return GridRegistrationFormConsumerComponent;
      case GridRegistrationTypeEnum.Storage:
        return GridRegistrationFormStorageWrapperComponent;
      case GridRegistrationTypeEnum.PlugInProducer:
        return GridRegistrationExternalFormComponent;
    }
  }
}

export function p14aApplies(
  consumerType: GridRegistrationTypeEnum | ConsumerType,
  consumerModel: ConsumerModel
): boolean {
  switch (consumerType) {
    case 'Charger':
      // switch case for all gid-registration-types :) this is only valid for chargers
      // eslint-disable-next-line no-case-declarations
      const isPrivate = consumerModel.location === 'Private';
      // eslint-disable-next-line no-case-declarations
      const isNoException = !consumerModel.isP14aStvoException;
      // eslint-disable-next-line no-case-declarations
      const isOverPowerThreshold = consumerModel.power && consumerModel.power > 4.2;
      return isPrivate && isNoException && isOverPowerThreshold;
    case 'Storage':
      return (consumerModel.power ?? 0) * (consumerModel.count ?? 0) > 4.2;
    case 'EHeating':
      return consumerModel.power * consumerModel.count > 4.2;
    default:
      return false;
  }
}

/**
 * Speicher-NA mit gespeicherter Erzeuger-Entladeleistung → Inbetriebsetzungs-Flow vor der Inbetriebnahme (analog Einspeiser).
 */
export function storagePlaceInServiceFlowEnabled(model: GridRegistrationModel | null | undefined): boolean {
  if (!model || model.gridRegistrationType !== GridRegistrationTypeEnum.Storage) {
    return false;
  }
  return (
    model.storages.some(
      (storage) =>
        storage.storageOperationType === StorageOperationTypeEnum.CONSUMPTION_PRODUCTION ||
        storage.storageOperationType === StorageOperationTypeEnum.NO_CONSUMPTION_PRODUCTION
    ) && !!model.producers?.some((p) => p.dischargePower != null)
  );
}
